import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DeleteLecture401,
  DeleteLecture403,
  DeleteLecture404,
  GetApiCoursesCourseIdLecturesLectureId200,
  GetApiCoursesCourseIdLecturesLectureId404,
  GetApiCoursesCourseIdLecturesLectureIdParams,
  GetCourseDetail200,
  GetCourseDetail400,
  GetCourseDetail401,
  GetCourseDetail403,
  GetCourseDetail404,
  GetCourseDetail500,
  GetCourseDetailParams,
  GetCourseDraftId200,
  GetCourseDraftId401,
  GetCourseDraftId403,
  GetCourseDraftId404,
  GetCourseDraftId500,
  MarkLectureAsCompleted200,
  MarkLectureAsCompleted401,
  MarkLectureAsCompleted403,
  MarkLectureAsCompleted404,
  ReportCourse400,
  ReportCourse401,
  ReportCourse404,
  ReportCourse500,
  ReportCourseBody,
  UploadLectureResource200,
  UploadLectureResource400,
  UploadLectureResource401,
  UploadLectureResource403,
  UploadLectureResource413,
  UploadLectureResourceBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 특정 강의를 상세 정보(요약, 설명, 커리큘럼)와 함께 조회합니다.
 * @summary 강의 상세 정보 조회
 */
export const getCourseDetail = (
    courseId: string,
    params?: GetCourseDetailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDetail200>(
      {url: `https://api.ugot.uk/api/courses/${courseId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCourseDetailQueryKey = (courseId: string,
    params?: GetCourseDetailParams,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseDetailInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDetail>>, TError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500>(courseId: string,
    params?: GetCourseDetailParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDetailQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDetail>>> = ({ signal }) => getCourseDetail(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDetail>>>
export type GetCourseDetailInfiniteQueryError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500

/**
 * @summary 강의 상세 정보 조회
 */
export const useGetCourseDetailInfinite = <TData = Awaited<ReturnType<typeof getCourseDetail>>, TError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500>(
 courseId: string,
    params?: GetCourseDetailParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDetailInfiniteQueryOptions(courseId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDetailQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDetail>>, TError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500>(courseId: string,
    params?: GetCourseDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDetailQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDetail>>> = ({ signal }) => getCourseDetail(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDetail>>>
export type GetCourseDetailQueryError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500

/**
 * @summary 강의 상세 정보 조회
 */
export const useGetCourseDetail = <TData = Awaited<ReturnType<typeof getCourseDetail>>, TError = GetCourseDetail400 | GetCourseDetail401 | GetCourseDetail403 | GetCourseDetail404 | GetCourseDetail500>(
 courseId: string,
    params?: GetCourseDetailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDetailQueryOptions(courseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 발행된 강의(published course)의 원본 초안(draft) ID를 조회합니다.
강사만 접근 가능합니다.

 * @summary 발행된 강의의 원본 초안 ID 조회
 */
export const getCourseDraftId = (
    courseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseDraftId200>(
      {url: `https://api.ugot.uk/api/courses/${courseId}/draft`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCourseDraftIdQueryKey = (courseId: string,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}/draft`] as const;
    }

    
export const getGetCourseDraftIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftId>>, TError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500>(courseId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftIdQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftId>>> = ({ signal }) => getCourseDraftId(courseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftId>>>
export type GetCourseDraftIdInfiniteQueryError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500

/**
 * @summary 발행된 강의의 원본 초안 ID 조회
 */
export const useGetCourseDraftIdInfinite = <TData = Awaited<ReturnType<typeof getCourseDraftId>>, TError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500>(
 courseId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftIdInfiniteQueryOptions(courseId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseDraftIdQueryOptions = <TData = Awaited<ReturnType<typeof getCourseDraftId>>, TError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500>(courseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseDraftIdQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseDraftId>>> = ({ signal }) => getCourseDraftId(courseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseDraftIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseDraftId>>>
export type GetCourseDraftIdQueryError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500

/**
 * @summary 발행된 강의의 원본 초안 ID 조회
 */
export const useGetCourseDraftId = <TData = Awaited<ReturnType<typeof getCourseDraftId>>, TError = GetCourseDraftId401 | GetCourseDraftId403 | GetCourseDraftId404 | GetCourseDraftId500>(
 courseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseDraftId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseDraftIdQueryOptions(courseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 부적절한 강의를 신고합니다.
 * @summary 강의 신고
 */
export const reportCourse = (
    courseId: string,
    reportCourseBody: ReportCourseBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/courses/${courseId}/report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportCourseBody
    },
      options);
    }
  


export const getReportCourseMutationOptions = <TError = ReportCourse400 | ReportCourse401 | ReportCourse404 | ReportCourse500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportCourse>>, TError,{courseId: string;data: ReportCourseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reportCourse>>, TError,{courseId: string;data: ReportCourseBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportCourse>>, {courseId: string;data: ReportCourseBody}> = (props) => {
          const {courseId,data} = props ?? {};

          return  reportCourse(courseId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportCourseMutationResult = NonNullable<Awaited<ReturnType<typeof reportCourse>>>
    export type ReportCourseMutationBody = ReportCourseBody
    export type ReportCourseMutationError = ReportCourse400 | ReportCourse401 | ReportCourse404 | ReportCourse500

    /**
 * @summary 강의 신고
 */
export const useReportCourse = <TError = ReportCourse400 | ReportCourse401 | ReportCourse404 | ReportCourse500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportCourse>>, TError,{courseId: string;data: ReportCourseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof reportCourse>>,
        TError,
        {courseId: string;data: ReportCourseBody},
        TContext
      > => {

      const mutationOptions = getReportCourseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 코스의 강의(lecture) 세부 정보를 조회합니다.
 * @summary 강의 세부 정보 조회
 */
export const getApiCoursesCourseIdLecturesLectureId = (
    courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiCoursesCourseIdLecturesLectureId200>(
      {url: `https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiCoursesCourseIdLecturesLectureIdQueryKey = (courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiCoursesCourseIdLecturesLectureIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError = GetApiCoursesCourseIdLecturesLectureId404>(courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCoursesCourseIdLecturesLectureIdQueryKey(courseId,lectureId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>> = ({ signal }) => getApiCoursesCourseIdLecturesLectureId(courseId,lectureId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCoursesCourseIdLecturesLectureIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>>
export type GetApiCoursesCourseIdLecturesLectureIdInfiniteQueryError = GetApiCoursesCourseIdLecturesLectureId404

/**
 * @summary 강의 세부 정보 조회
 */
export const useGetApiCoursesCourseIdLecturesLectureIdInfinite = <TData = Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError = GetApiCoursesCourseIdLecturesLectureId404>(
 courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiCoursesCourseIdLecturesLectureIdInfiniteQueryOptions(courseId,lectureId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiCoursesCourseIdLecturesLectureIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError = GetApiCoursesCourseIdLecturesLectureId404>(courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCoursesCourseIdLecturesLectureIdQueryKey(courseId,lectureId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>> = ({ signal }) => getApiCoursesCourseIdLecturesLectureId(courseId,lectureId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCoursesCourseIdLecturesLectureIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>>
export type GetApiCoursesCourseIdLecturesLectureIdQueryError = GetApiCoursesCourseIdLecturesLectureId404

/**
 * @summary 강의 세부 정보 조회
 */
export const useGetApiCoursesCourseIdLecturesLectureId = <TData = Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError = GetApiCoursesCourseIdLecturesLectureId404>(
 courseId: string,
    lectureId: string,
    params?: GetApiCoursesCourseIdLecturesLectureIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCoursesCourseIdLecturesLectureId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiCoursesCourseIdLecturesLectureIdQueryOptions(courseId,lectureId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 코스의 강의(lecture)를 삭제합니다.
 * @summary 강의 삭제
 */
export const deleteLecture = (
    courseId: string,
    lectureId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLectureMutationOptions = <TError = DeleteLecture401 | DeleteLecture403 | DeleteLecture404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLecture>>, TError,{courseId: string;lectureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLecture>>, TError,{courseId: string;lectureId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLecture>>, {courseId: string;lectureId: string}> = (props) => {
          const {courseId,lectureId} = props ?? {};

          return  deleteLecture(courseId,lectureId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLectureMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLecture>>>
    
    export type DeleteLectureMutationError = DeleteLecture401 | DeleteLecture403 | DeleteLecture404

    /**
 * @summary 강의 삭제
 */
export const useDeleteLecture = <TError = DeleteLecture401 | DeleteLecture403 | DeleteLecture404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLecture>>, TError,{courseId: string;lectureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteLecture>>,
        TError,
        {courseId: string;lectureId: string},
        TContext
      > => {

      const mutationOptions = getDeleteLectureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 강의를 완료 상태로 변경합니다.
 * @summary 강의 완료 처리
 */
export const markLectureAsCompleted = (
    lectureId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MarkLectureAsCompleted200>(
      {url: `https://api.ugot.uk/api/lectures/${lectureId}/complete`, method: 'POST'
    },
      options);
    }
  


export const getMarkLectureAsCompletedMutationOptions = <TError = MarkLectureAsCompleted401 | MarkLectureAsCompleted403 | MarkLectureAsCompleted404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLectureAsCompleted>>, TError,{lectureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof markLectureAsCompleted>>, TError,{lectureId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markLectureAsCompleted>>, {lectureId: string}> = (props) => {
          const {lectureId} = props ?? {};

          return  markLectureAsCompleted(lectureId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkLectureAsCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof markLectureAsCompleted>>>
    
    export type MarkLectureAsCompletedMutationError = MarkLectureAsCompleted401 | MarkLectureAsCompleted403 | MarkLectureAsCompleted404

    /**
 * @summary 강의 완료 처리
 */
export const useMarkLectureAsCompleted = <TError = MarkLectureAsCompleted401 | MarkLectureAsCompleted403 | MarkLectureAsCompleted404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markLectureAsCompleted>>, TError,{lectureId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof markLectureAsCompleted>>,
        TError,
        {lectureId: string},
        TContext
      > => {

      const mutationOptions = getMarkLectureAsCompletedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 강의에 파일을 업로드하고 자동으로 자료로 등록합니다.
 * @summary 강의 자료 업로드
 */
export const uploadLectureResource = (
    courseId: string,
    lectureId: string,
    uploadLectureResourceBody: UploadLectureResourceBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      const formData = new FormData();
formData.append('file', uploadLectureResourceBody.file)
if(uploadLectureResourceBody.title !== undefined) {
 formData.append('title', uploadLectureResourceBody.title)
 }

      return customInstance<UploadLectureResource200>(
      {url: `https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getUploadLectureResourceMutationOptions = <TError = UploadLectureResource400 | UploadLectureResource401 | UploadLectureResource403 | UploadLectureResource413,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLectureResource>>, TError,{courseId: string;lectureId: string;data: UploadLectureResourceBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadLectureResource>>, TError,{courseId: string;lectureId: string;data: UploadLectureResourceBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLectureResource>>, {courseId: string;lectureId: string;data: UploadLectureResourceBody}> = (props) => {
          const {courseId,lectureId,data} = props ?? {};

          return  uploadLectureResource(courseId,lectureId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadLectureResourceMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLectureResource>>>
    export type UploadLectureResourceMutationBody = UploadLectureResourceBody
    export type UploadLectureResourceMutationError = UploadLectureResource400 | UploadLectureResource401 | UploadLectureResource403 | UploadLectureResource413

    /**
 * @summary 강의 자료 업로드
 */
export const useUploadLectureResource = <TError = UploadLectureResource400 | UploadLectureResource401 | UploadLectureResource403 | UploadLectureResource413,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLectureResource>>, TError,{courseId: string;lectureId: string;data: UploadLectureResourceBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadLectureResource>>,
        TError,
        {courseId: string;lectureId: string;data: UploadLectureResourceBody},
        TContext
      > => {

      const mutationOptions = getUploadLectureResourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    